import { render, staticRenderFns } from "./MaterialPricingCard.vue?vue&type=template&id=22c4bbfa&scoped=true"
import script from "./MaterialPricingCard.vue?vue&type=script&lang=js"
export * from "./MaterialPricingCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialPricingCard.vue?vue&type=style&index=0&id=22c4bbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4bbfa",
  null
  
)

export default component.exports